// services/personal.service.ts
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Education } from '../store/education/education.state'
import { eps } from './url.service'

@Injectable({ providedIn: 'root' })
export class EducationService {
  private apiUrl = eps.education.educationApi

  constructor(private http: HttpClient) {}

  getEducations(
    params: string | null,
    page: number | null | undefined,
    limit: number | null | undefined
  ): Observable<{ educations: Education[] }> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<{ educations: Education[] }>(url)
  }

  createEducation(payload: any): Observable<any> {
    console.log('api', this.apiUrl)
    return this.http.post(`${this.apiUrl}`, payload)
  }

  updateEducation(id: string, payload: any): Observable<Education> {
    return this.http.put<Education>(`${this.apiUrl}/${id}`, payload)
  }

  deleteEducation(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {})
  }
}
